import React from 'react';
import { useTranslator } from 'tradera-lang/translate';
import InfoTooltip from './info-tooltip';
import { mapCountryCodeToCountryKey } from 'tradera-localization/countries';
import LeafIcon from '@tradera/blueprint/theme/icons2/leaf.svg?jsx';
import styles from './shipping-options.module.scss';

export const OptionsDisplay = ({ options, shouldShowFromCountry }) => {
    const { t } = useTranslator();
    return options.map((option, idx) => (
        <p key={`${option.displayText}${idx}`} className="mb-1">
            <span className="align-middle my-1">
                {option.displayText}
                {option.hasClimateCompensation ? (
                    <span className="text-success tooltip_container ml-1">
                        <LeafIcon className="icon" />
                        <span
                            className={`tooltip tooltip-success px-1 py-0 text-nowrap ${styles.minWidth0}`}>
                            {t('vip_shipping_climateCompensation')}
                        </span>
                    </span>
                ) : null}
                {shouldShowFromCountry && (
                    <>
                        {' '}
                        {t('vip_shipping_options_to_text')}{' '}
                        {t(
                            mapCountryCodeToCountryKey(option.toCountryCodeIso2)
                        )}
                    </>
                )}
            </span>
            {option.tooltipText && (
                <InfoTooltip
                    className="ml-1"
                    displayText={option.tooltipText}
                />
            )}
        </p>
    ));
};
